const LOGIN_PATH = '/login'

// Pages a user is never sent back to after signing in.
const NOT_DESTINATIONS = ['/', '/login', '/logout']

export function isOnLoginPage() {
  return window.location.pathname === LOGIN_PATH
}

/**
 * URL of Tracer's sign-in page, carrying where the user was headed so they can
 * be returned there. Only a real destination is carried: the sign-in and
 * logout pages, and the home page the user lands on anyway, are left out.
 */
export function loginPath() {
  const { pathname } = window.location

  if (NOT_DESTINATIONS.includes(pathname)) {
    return LOGIN_PATH
  }

  return `${LOGIN_PATH}?redirect_url=${encodeURIComponent(pathname)}`
}
